import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { getLabelTranslationKey } from '../../Utils/dimensionsMapper';

const COLORS = ['#00A4A6', '#6CC24A', '#00D4FF', '#FFA500', '#8B5CF6'];

const PieChartWidget = ({ data, config }) => {
    const { t } = useTranslation();
    const nameKey = config?.config?.nameKey || config?.nameKey || 'name';
    const valueKey = config?.config?.valueKey || config?.valueKey || 'value';

    // Translate data labels
    const translatedData = useMemo(() => {
        if (!Array.isArray(data) || data.length === 0) {
            return [];
        }
        return data.map(item => ({
            ...item,
            [nameKey]: (() => {
                const translationKey = getLabelTranslationKey(item[nameKey]);
                return translationKey !== item[nameKey] ? t(translationKey) : item[nameKey];
            })()
        }));
    }, [data, nameKey, t]);

    // Safety check: ensure data is an array
    if (!Array.isArray(data) || data.length === 0) {
        return null;
    }

    return (
        <ResponsiveContainer width="100%" height="100%">
            <PieChart>
                <Pie data={translatedData} dataKey={valueKey} nameKey={nameKey} cx="50%" cy="50%" outerRadius={80}>
                    {translatedData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                </Pie>
                <Tooltip />
                <Legend />
            </PieChart>
        </ResponsiveContainer>
    );
};

export default PieChartWidget;
